export default __webpack_public_path__ + "static/media/event2.18d78a38.jpg";